import React from 'react'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import Router from '@/modern/components/Router'
import { TokenProvider } from '@/store/context/token-provider/token-provider'
import { CookieNoticeProvider } from '../store/context/cookie-notice-context'
import configureStore from './store'
import theme from '../styles/theme'
import Perimeterex from './perimeterex'
import { AuthProvider, configureAuth } from '@webmotors/consumer-shared-auth'
import { config } from 'config/config'

const initialState = window.INITIAL_STATE
const store = configureStore(initialState)

function resolveAuthConfig() {
  return {
    env: process.env.NODE_ENV,
    loginUrl: config.urlLogin,
  }
}

configureAuth(resolveAuthConfig())

export default () => {
  return (
    <CookieNoticeProvider>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <TokenProvider>
            <AuthProvider>
              <Router />
              <Perimeterex />
            </AuthProvider>
          </TokenProvider>
        </Provider>
      </ThemeProvider>
    </CookieNoticeProvider>
  )
}
